import { differenceInDays, format } from "date-fns";

export const OLD_VM_RETIREMENT_DATE = new Date("2026-06-13");

// 5pm Sydney time (AEST = UTC+10) on June 13
export const OLD_VM_RETIREMENT_DATETIME = new Date("2026-06-13T17:00:00+10:00");

export const OLD_VM_RETIREMENT_DATE_FORMATTED = format(OLD_VM_RETIREMENT_DATE, "dd MMM yyyy");
export const OLD_VM_RETIREMENT_DATE_SHORT = format(OLD_VM_RETIREMENT_DATE, "dd MMM");

export const getOldVmDaysLeft = () => Math.max(0, differenceInDays(OLD_VM_RETIREMENT_DATE, new Date()));

// Migration started May 13 midnight Sydney time (AEST = UTC+10)
export const OLD_VM_MIGRATION_START_DATE = new Date("2026-05-13T00:00:00+10:00");

export const isOldVmRetired = () => new Date() >= OLD_VM_RETIREMENT_DATETIME;

export const isOperatorCreatedAfterMigration = (joinedDate: string) => new Date(joinedDate) >= OLD_VM_MIGRATION_START_DATE;
